import { DocumentData } from 'firebase/firestore';

export type CardContentId = string;
export type ContentImage = {
  id: number; // necessary?
  url?: string;
  base64?: string;
};

export class CardContent {
  language?: string;
  html?: string;
  order?: number;
  isCorrect?: boolean;

  constructor(
    language: string | undefined,
    html: string | undefined,
    order?: number,
    isCorrect?: boolean
  ) {
    this.language = language;
    this.html = html;
    this.order = order;
    this.isCorrect = isCorrect ?? false;
  }
}

export const cardContentEqualsCardContent = (
  it: CardContent | undefined,
  other: CardContent | undefined
) => {
  if (it === undefined && other === undefined) {
    return true;
  } else if (it === undefined || other === undefined) {
    return false;
  }
  return (
    it.language === other.language &&
    it.html === other.html &&
    it.order === other.order &&
    it.isCorrect === other.isCorrect
  );
};

export const cardContentConverter = {
  toFirestore: (cardContent: CardContent | undefined) => {
    if (!cardContent) {
      return null;
    }
    return {
      language: cardContent?.language || null,
      html: cardContent?.html || null,
      order: cardContent?.order || null,
      isCorrect: cardContent?.isCorrect || false,
    };
  },
  fromFirestore2: (data: DocumentData) => {
    if (!data) {
      return undefined;
    }
    return new CardContent(
      data['language'] ?? undefined,
      data['html'] ?? undefined,
      data['order'] ?? undefined,
      data['isCorrect'] ?? false
    );
  },
};
